module.exports = "<p-menubar [styleClass]=\"\" [model]=\"menu\"></p-menubar>\n\n\n    \n"